export const AUTH_USER_STORAGE_KEY = "openfarming.auth.user";

function canUseLocalStorage() {
  return (
    typeof window !== "undefined" && typeof window.localStorage !== "undefined"
  );
}

export function getStoredUserString() {
  if (!canUseLocalStorage()) {
    return null;
  }

  return window.localStorage.getItem(AUTH_USER_STORAGE_KEY);
}

export function setStoredUserString(user: string | null) {
  if (!canUseLocalStorage()) {
    return;
  }

  if (user) {
    window.localStorage.setItem(AUTH_USER_STORAGE_KEY, user);
    return;
  }

  window.localStorage.removeItem(AUTH_USER_STORAGE_KEY);
}

function isStoredUser(value: unknown): value is { id: number } {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }

  const id = (value as { id?: unknown }).id;
  return typeof id === "number" && Number.isFinite(id);
}

export function hasStoredUser() {
  const storedUser = getStoredUserString();

  if (!storedUser) {
    return false;
  }

  try {
    if (isStoredUser(JSON.parse(storedUser))) {
      return true;
    }
  } catch {
    // Invalid values are removed below.
  }

  setStoredUserString(null);
  return false;
}

export function getStoredUserId() {
  const storedUser = getStoredUserString();

  if (!storedUser) {
    return undefined;
  }

  try {
    const parsedUser = JSON.parse(storedUser) as { id?: unknown };
    return typeof parsedUser.id === "number" ? parsedUser.id : undefined;
  } catch {
    return undefined;
  }
}

export function getStoredSupplierRole() {
  const storedUser = getStoredUserString();

  if (!storedUser) {
    return undefined;
  }

  try {
    const parsedUser = JSON.parse(storedUser) as { supplierRole?: unknown };
    return typeof parsedUser.supplierRole === "string"
      ? parsedUser.supplierRole
      : undefined;
  } catch {
    return undefined;
  }
}
